import React from 'react'
import AdminLayout from '../../../layouts/AdminLayout'
import { Navigate, useNavigate } from 'react-router-dom'
import { adminPaths } from '../../../routes/admin'

const Report = () => {
  const navigate = useNavigate();
  return (
    <div>
      <AdminLayout>
        <div className="ct_px_40 my-5">
          <div className="container-fluid">
            <div className="row gx-5">
              <div className="col-lg-2 col-md-3 mb-4 mb-md-0">
                <h4 className="mb-0 ct_fs_20 mb-4">Reports</h4>
                <div className="ct_filter_btn">
                  <button
                    className="ct_outline_grey ct_yellow_btn ct_h_35 d-flex align-items-center gap-2"

                  >
                    Filter <img src="/assets/img/octicon_filter-16.png" alt="" />
                  </button>
                </div>
                <div
                  className="ct_filter_sidebar ct_custom_scroll p-0 "
                >
                  <div
                    className="ct_close_filter d-block d-lg-none"

                  >
                    <i className="fa-solid fa-xmark"></i>
                  </div>
                  <div className="mt-4">
                    <h5 className="ct_fs_16 mb-3">Status</h5>
                    <ul>
                      <li>
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Ready
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Scheduled
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            In Progress
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Failed
                          </label>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="mt-4">
                    <h5 className="ct_fs_16 mb-3">Generated by</h5>
                    <ul>
                      <li>
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            System
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Admin team
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Admin
                          </label>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="mt-4">
                    <h5 className="ct_fs_16 mb-3">Category</h5>
                    <ul>
                      <li>
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            EdTech
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            HealthTech
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Design
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Product
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Development
                          </label>
                        </div>
                      </li>
                    </ul>
                  </div>

                </div>
              </div>
              <div className='col-lg-10 col-md-9 mb-4 mb-md-0'>
                <div className="d-flex align-items-center gap-3 justify-content-between mb-4 ct_flex_col_1199">
                  <div>
                    <h4 className="mb-0 ct_fs_20  mb-0">Platform Reports</h4>
                    <p className="mb-0 ct_text_clr_757886">
                      Fit insights into platform activity, user growth, project status and service performance
                    </p>
                  </div>
                  <div className="d-flex align-items-center gap-3 ct_flex_col_575 ct_w_100_575">
                    <div className="position-relative ct_w_100_575">
                      <input
                        type="text"
                        className="form-control ct_input ct_h_40 ps-5 ct_border_radius_20"
                        placeholder="Search by Name"
                      />
                      <i className="fa-solid fa-search ct_input_icon_left"></i>
                    </div>
                    <button className='ct_yellow_btn ct_h_40'>
                      <i class="fa-solid fa-plus me-1 ct_fs_14"></i> Create New Report
                    </button>

                  </div>
                </div>


                <div class="table-responsive ct_custom_table ct_custom_table2 pt-2">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Category</th>
                        <th>Date Range</th>
                        <th>Status</th>
                        <th>Generated By</th>
                        <th></th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <h5 class="ct_fs_16  mb-0">Monthly Platform Activity</h5>
                        </td>
                        <td>Overview</td>
                        <td>May 1 -May 31</td>
                        <td>
                          <span class="ct_publish_badge">Ready</span>
                        </td>
                        <td>
                          <div className='position-relative'>
                            <select class="form-control ct_input border-0 pe-5">
                              <option value="">System</option>
                            </select>
                            <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                          </div>
                        </td>
                        <td>
                          <div class="ct_right_dropdown dropdown">
                            <button
                              id="dropdownMenuButton"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa-solid fa-ellipsis"></i>
                            </button>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <a
                                  class="dropdown-item"
                                  onClick={() => navigate(adminPaths?.ReportDetails)}

                                >View Report</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_darksky_blue_text"

                                  href="javascript:void(0)"
                                >Download PDF</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_yellow_text"
                                  href="javascript:void(0)"

                                >Schedule New Report
                                </a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_orange_text"
                                  href="javascript:void(0)"
                                  data-bs-target="#ct_suspend_account"
                                  data-bs-toggle="modal"
                                >Edit Parameters
                                </a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item text-danger"
                                  href="javascript:void(0)"

                                >Delete Reports
                                </a>
                              </li>
                            </ul>
                          </div>
                        </td>


                      </tr>
                      <tr>
                        <td>
                          <h5 class="ct_fs_16  mb-0">Monthly Platform Activity</h5>
                        </td>
                        <td>Overview</td>
                        <td>May 1 -May 31</td>
                        <td>
                          <span class="ct_publish_badge">Ready</span>
                        </td>
                        <td>
                          <div className='position-relative'>
                            <select class="form-control ct_input border-0 pe-5">
                              <option value="">System</option>
                            </select>
                            <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                          </div>
                        </td>
                        <td>
                          <div class="ct_right_dropdown dropdown">
                            <button
                              id="dropdownMenuButton"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa-solid fa-ellipsis"></i>
                            </button>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <a
                                  class="dropdown-item"
                                  onClick={() => navigate(adminPaths?.ReportDetails)}

                                >View Report</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_darksky_blue_text"

                                  href="javascript:void(0)"
                                >Download PDF</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_yellow_text"
                                  href="javascript:void(0)"

                                >Schedule New Report
                                </a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_orange_text"
                                  href="javascript:void(0)"
                                  data-bs-target="#ct_suspend_account"
                                  data-bs-toggle="modal"
                                >Edit Parameters
                                </a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item text-danger"
                                  href="javascript:void(0)"

                                >Delete Reports
                                </a>
                              </li>
                            </ul>
                          </div>
                        </td>


                      </tr>
                      <tr>
                        <td>
                          <h5 class="ct_fs_16  mb-0">Monthly Platform Activity</h5>
                        </td>
                        <td>Overview</td>
                        <td>May 1 -May 31</td>
                        <td>
                          <span class="ct_publish_badge">Ready</span>
                        </td>
                        <td>
                          <div className='position-relative'>
                            <select class="form-control ct_input border-0 pe-5">
                              <option value="">System</option>
                            </select>
                            <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                          </div>
                        </td>
                        <td>
                          <div class="ct_right_dropdown dropdown">
                            <button
                              id="dropdownMenuButton"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa-solid fa-ellipsis"></i>
                            </button>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <a
                                  class="dropdown-item"
                                  onClick={() => navigate(adminPaths?.ReportDetails)}

                                >View Report</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_darksky_blue_text"

                                  href="javascript:void(0)"
                                >Download PDF</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_yellow_text"
                                  href="javascript:void(0)"

                                >Schedule New Report
                                </a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_orange_text"
                                  href="javascript:void(0)"
                                  data-bs-target="#ct_suspend_account"
                                  data-bs-toggle="modal"
                                >Edit Parameters
                                </a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item text-danger"
                                  href="javascript:void(0)"

                                >Delete Reports
                                </a>
                              </li>
                            </ul>
                          </div>
                        </td>


                      </tr>
                      <tr>
                        <td>
                          <h5 class="ct_fs_16  mb-0">Monthly Platform Activity</h5>
                        </td>
                        <td>Overview</td>
                        <td>May 1 -May 31</td>
                        <td>
                          <span class="ct_schedule_badge">Scheduled</span>
                        </td>
                        <td>
                          <div className='position-relative'>
                            <select class="form-control ct_input border-0 pe-5">
                              <option value="">System</option>
                            </select>
                            <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                          </div>
                        </td>
                        <td>
                          <div class="ct_right_dropdown dropdown">
                            <button
                              id="dropdownMenuButton"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa-solid fa-ellipsis"></i>
                            </button>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <a
                                  class="dropdown-item"
                                  onClick={() => navigate(adminPaths?.ReportDetails)}

                                >View Report</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_darksky_blue_text"

                                  href="javascript:void(0)"
                                >Download PDF</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_yellow_text"
                                  href="javascript:void(0)"

                                >Schedule New Report
                                </a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_orange_text"
                                  href="javascript:void(0)"
                                  data-bs-target="#ct_suspend_account"
                                  data-bs-toggle="modal"
                                >Edit Parameters
                                </a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item text-danger"
                                  href="javascript:void(0)"

                                >Delete Reports
                                </a>
                              </li>
                            </ul>
                          </div>
                        </td>


                      </tr>
                      <tr>
                        <td>
                          <h5 class="ct_fs_16  mb-0">Monthly Platform Activity</h5>
                        </td>
                        <td>Overview</td>
                        <td>May 1 -May 31</td>
                        <td>
                          <span class="ct_schedule_badge">Scheduled</span>
                        </td>
                        <td>
                          <div className='position-relative'>
                            <select class="form-control ct_input border-0 pe-5">
                              <option value="">System</option>
                            </select>
                            <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                          </div>
                        </td>
                        <td>
                          <div class="ct_right_dropdown dropdown">
                            <button
                              id="dropdownMenuButton"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa-solid fa-ellipsis"></i>
                            </button>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <a
                                  class="dropdown-item"
                                  onClick={() => navigate(adminPaths?.ReportDetails)}

                                >View Report</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_darksky_blue_text"

                                  href="javascript:void(0)"
                                >Download PDF</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_yellow_text"
                                  href="javascript:void(0)"

                                >Schedule New Report
                                </a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_orange_text"
                                  href="javascript:void(0)"
                                  data-bs-target="#ct_suspend_account"
                                  data-bs-toggle="modal"
                                >Edit Parameters
                                </a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item text-danger"
                                  href="javascript:void(0)"

                                >Delete Reports
                                </a>
                              </li>
                            </ul>
                          </div>
                        </td>


                      </tr>


                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>
      </AdminLayout>
    </div>
  )
}

export default Report